export class Resource {
  id: number;
  version: number;
  ativo: boolean = true;
}
